/* LIBRAIRIES */
import React, { useState, useEffect } from 'react';
import { TailSpin } from "react-loader-spinner";

/* COMPONENT */
import CustomAlert from '../CustomAlert/CustomAlert';

/* MUI */
import { Button, Select, MenuItem } from '@mui/material';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { FaUserCircle } from 'react-icons/fa';

/* CONTEXT */
import { useUserContext } from '../../useContext';

/* CSS */
import './ModalUser.css';

/* Firebase */
import { getAuth, updateEmail, updatePassword } from "firebase/auth";
import { getFirestore, doc, updateDoc } from "firebase/firestore";
import { app } from '../../firebase';

const ModalUser = ({ openProfil, setOpenProfil }) => {

    const { userInfos } = useUserContext(); 
    const [email, setEmail] = useState(userInfos?.email || '');
    const [name, setName] = useState(userInfos?.name || '');
    const [firstName, setFirstName] = useState(userInfos?.firstName || '');
    const [password, setPassword] = useState('');
    const [openAlert, setOpenAlert] = useState(false);
    const [alertSeverity, setAlertSeverity] = useState("success");
    const [alertMessage, setAlertMessage] = useState("");

    const auth = getAuth(app);

    const handleClose = () => {
        setOpenProfil(false);
    };

    const updateUser = async (email, password, name, firstName) => {
        try {
            // Mettre à jour l'email et/ou le mot de passe dans l'authentification Firebase
            if (userInfos?.email !== email) {
                await updateEmail(auth.currentUser, email);
            }
            if (password) {
                await updatePassword(auth.currentUser, password);
            }
            const db = getFirestore();

            // Mettre à jour le nom et/ou le prénom dans la base de données Firestore
            const userRef = doc(db, "users", auth.currentUser.uid);
            await updateDoc(userRef, {
                email,
                name,
                firstName
            });
            setAlertSeverity("success");
            setAlertMessage("Mise à jour de l'utilisateur réussie !");
            setOpenAlert(true);
            console.log("Mise à jour de l'utilisateur réussie !");
        } catch (error) {
            setAlertSeverity("error");
            setAlertMessage(error);
            setOpenAlert(true);
            console.log(error);
        } finally {
            handleClose();
        }
    }

    const handleUpdate = async () => {
        await updateUser(email, password, name, firstName);
        handleClose();
    };

    const handleCloseAlert = () => {
        setOpenAlert(false);
    }
  
    return (
      <div>
        {/* <Button variant="outlined" onClick={handleClickOpen}>
          Open form dialog
        </Button> */}
        <Dialog open={openProfil} onClose={handleClose}>
          <DialogTitle>Profil utilisateur</DialogTitle>
          <DialogContent>
            <div className='flex-center'>
                <FaUserCircle className='img-user'/>
                <div className='status-user'>{userInfos?.role || ""}</div>
            </div>
            <TextField
              autoFocus
              margin="dense"
              id="email"
              label="Email Address"
              type="email"
              fullWidth
              variant="standard"
              value={email || ""}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Nom"
              type="text"
              fullWidth
              variant="standard"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <TextField
              autoFocus
              margin="dense"
              id="prenom"
              label="Prénom"
              type="text"
              fullWidth
              variant="standard"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
            <TextField
              autoFocus
              margin="dense"
              id="mdp"
              label="Mot de passe"
              type="password"
              fullWidth
              variant="standard"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button variant="contained" onClick={handleClose}>Annuler</Button>
            <Button variant="contained" onClick={handleUpdate}>Modifier</Button>
          </DialogActions>
        </Dialog>
        <CustomAlert 
            open={openAlert}
            onClose={handleCloseAlert}
            message={alertMessage}
            severity={alertSeverity}
        />
      </div>
    );
}

export default ModalUser;